/**
 * `customers.customer_status` checks for order placement (CWS-1451).
 *
 * An admin can set a customer inactive from the customer details screen; no order may be
 * placed for them until they are reactivated. svc-order enforces this and returns the same
 * copy; the modal checks first so staff learn before filling in the whole order.
 */

/** Same copy as svc-order `CUSTOMER_INACTIVE_MESSAGE`. Plain on purpose: `sanitizeErrorMessage` keeps it. */
export const CUSTOMER_INACTIVE_MESSAGE =
  'This customer is inactive. Reactivate the customer to place an order.';

/** `refusal_reason` on an LPR create-order-request for an inactive customer's vehicle. */
export const CUSTOMER_INACTIVE_REFUSAL_REASON = 'customer_inactive';

/**
 * Only an explicit `'inactive'` counts. `customer_status` is a nullable VARCHAR defaulting to
 * `'active'`, so a missing value must not block an order — unlike `isSegmentCustomerActive`,
 * which answers the opposite question for display.
 */
export function isCustomerInactive(customerStatus: unknown): boolean {
  return (
    String(customerStatus ?? '')
      .trim()
      .toLowerCase() === 'inactive'
  );
}
